import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFluentdComponent } from './simple-icons-fluentd.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFluentdComponent ],
    exports:      [ SimpleIconsFluentdComponent ],
    bootstrap:    []
})
export class SimpleIconsFluentdModule {}
